module.exports = __webpack_public_path__ + "img/modifications--with_mattras.e12d6109.jpg";